import React from "react";
import {Space} from "antd";

export default props => {
    return <Space {...props} style={{width:'100%', ...(props.style || {})}} direction={'vertical'}>{props.children}</Space>
}